import React from "react";
import DataTable from 'react-data-table-component';

export default function CommanBarTable_Bus(props) {
  let data = props.data
  // let tabDataKey = props.tabDataKey
  // let noFifty = props.hasOwnProperty("noFifty")

  const columns = [
    {
      name: 'Vin Number',
      selector: (row) => row.key.vehicleId,
      sortable: true,
      width: '25%',
    },
    {
      name: 'City',
      // selector: (row) => (noFifty) ? row[tabDataKey].value.toFixed(2) : row[tabDataKey].values["50.0"].toFixed(2),
      selector: (row) => row.key.DLR_ORG_CITY,
      sortable: true,
      // width: '15%',
      // cell: (row) => (
      //   <span>{(noFifty) ? row[tabDataKey].value.toFixed(2) : row[tabDataKey].values["50.0"].toFixed(2)}</span>
      // ),
    },
    {
      name: 'Depo',
      selector: (row) => row.key.Depot_Name,
      sortable: true,
      // width: '20%',
    },
    {
      name: 'Duration',
      selector: (row) => Number(row.duration.value.toFixed(2)),
      sortable: true,
      // width: '20%',
      // cell: (row) => (
      //   <span>{row.duration.value.toFixed(2)}</span>
      // ),
      // sortFunction: (a, b) => parseFloat(a) - parseFloat(b),
    },
    {
      name: 'Occurence',
      selector: (row) => row.occurance.value,
      sortable: true,
      // width: '20%',
    }
  ];

  // if(props.unit === 'sp'){
  //   columns.pop()
  // }

  const filteredColumns = props.unit === 'sp'
  ? columns.filter(column => column.name !== 'Occurence')
  : columns;


  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#83A4CF',
        color: '#fff',
        fontWeight: 'bold'
      },
    },
  };

  return (
    <>

      {/* {(data.length === 0) ? "<tr><td colSpan={2}>No data found</td></tr>" : data.map((x, index) => {
        return (<tr key={index}>
          <td scope="row">{x.key.vehicleId}</td>
          {
            (noFifty) ?
              <td >{(x[tabDataKey].value).toFixed(2)} </td>
              :
              <td >{(x[tabDataKey].values["50.0"]).toFixed(2)} </td>
          }
          <td scope="row">{x.key.vehicle_registration_number}</td>
          <td scope="row">{x.key.Depot_Name}</td>
          <td scope="row">{x.key.DLR_ORG_CITY}</td>
        </tr>)
      })} */}
      {/* <div style={{ height: '250px', overflowY: 'auto' }}> */}
      <DataTable
        columns={filteredColumns}
        data={data}
        customStyles={customStyles}
        fixedHeader={true}
        fixedHeaderScrollHeight='250px'
      />
    </>
  );
}